import './App.css';

import NavBarItem from './components/SideBar/SideBarItem';
import SideBar from './components/SideBar';
import Main from './components/Main';
// import 

function App() {
  return (
    <div className="App">
      <SideBar />
      <Main />
    </div>
  );
}

export default App;
